/**
 * Truncates a string-like value to a safe analytics length.
 *
 * @param {any} value
 * @param {number} [maxLength=120]
 * @returns {string|undefined}
 */
function truncateString(value, maxLength = 120) {
  if (value == null) {
    return undefined
  }

  const normalized = String(value).trim()
  return normalized.length <= maxLength
    ? normalized
    : normalized.slice(0, maxLength)
}

export { truncateString }
